import React, { Component } from "react";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
class Idea extends Component {
  state = {};
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false,
    };
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  }
  renderViewMore(description) {
    if (description.length > 500) {
      return (
        <a
          href="# "
          className={this.state.popoverOpen ? "invisible" : "visible"}
          onClick={this.toggle}
        >
          ...more
        </a>
      );
    }
  }
  renderVoteButton(idea) {
    if (!idea.userAlreadyVoted) {
      if (idea.status === "Under Consideration") {
        return (
          <div>
            <button
              className="btn btn-outline-success btn-sm mt-2"
              onClick={() => {
                this.props.onVote(idea);
              }}
            >
              <FontAwesomeIcon icon="thumbs-up" /> Vote
            </button>
          </div>
        );
      }
    } else {
      return (
        <span className="text-success mt-1">
          <FontAwesomeIcon icon="check" /> Voted
        </span>
      );
    }
  }
  showDetails(idea) {}
  render() {
    const { idea } = this.props;
    return (
      <React.Fragment>
        <div className="mix card card-task" data-order={idea.totalVotes}>
          <div className="progress">
            <div
              className={"progress-bar badge-" + idea.module.replace(/ /g, "")}
              role="progressbar"
              style={{ width: "20%" }}
              aria-valuenow="60"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
          <div className="card-body">
            <div className="card-title d-flex flex-row">
              <div className="vote">
                <div className="vote-number badge badge-info">
                  {idea.totalVotes}

                  <p>votes</p>
                </div>

                {this.renderVoteButton(idea)}
              </div>
              <div className="suggestion-body flex-grow-1">
                <h6>{idea.title}</h6>
                <div
                  className={
                    "badge badge-warning badge-module badge-" +
                    idea.module.replace(/ /g, "")
                  }
                >
                  {idea.module}
                </div>
                <div className="text-small" style={{ whiteSpace: "pre-wrap" }}>
                  {idea.description.substring(0, 500)}
                  {this.renderViewMore(idea.description)}
                  <Collapse isOpen={this.state.popoverOpen} className="">
                    {idea.description.substring(500, 10000)}{" "}
                    <a href="# " onClick={this.toggle}>
                      ...less
                    </a>
                  </Collapse>
                </div>
              </div>
            </div>
            <div className="card-meta"></div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Idea;
